var _mask, _rect, _path, _mask2, _rect2, _mask3, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministrative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_680_1118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 8,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_680_1118)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.5L12 9.5L5.5 15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_680_1118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 7,
    height: 7,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-3-inside-2_680_1118)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_680_1118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 7,
    height: 7,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-4-inside-3_680_1118)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrative);
export default __webpack_public_path__ + "static/media/Administrative.09cf8daf.svg";
export { ForwardRef as ReactComponent };